module.exports = __webpack_public_path__ + "img/smm-1.d5aab092.png";